/**
 * OmniCommerce Shopify App Store compliance holds.
 *
 * Say "turn the Shopify App Store holds back on" when review is done and
 * you are ready to restore Riverr Stripe / Connect / SaaS billing.
 *
 * Flip `enabled` to false to restore every temporary hold at once.
 * Or flip a single key. Permanent App Store rules stay on even if
 * `enabled` is false — those are listing requirements, not review hacks.
 *
 * Tenant: OmniCommerce / Fabritech
 *   enterpriseId ZrinGQi7xo885EYe1Ti8
 *   hosts omnicommerce.myriverr.com, fabritech.myriverr.com
 */

export const SHOPIFY_APP_STORE_HOLDS = {
  /** Master switch for temporary review hides. */
  enabled: true,

  /** Free/Growth/Business, Settings → Billing, and lock-to-/pricing. The trial countdown is always hidden on Omni. */
  saasPricingAndSubscriptions: false,

  /** AI credit pack purchase (Settings page + in-app Stripe quick-buy). */
  aiCreditPurchase: false,

  /** Popup-store / fulfillment Stripe Connect bank payouts, including Profile, dashboard “Connect payouts”, and Fulfillment billing → Earnings. */
  connectPayouts: false,

  /** Hide Riverr card-upload from Omni sellers. Print-shop admin can add a card for COGS. */
  paymentMethodPrompts: false,

  /** Catalog “Bulk create products” merch-drop maker. */
  bulkProductMaker: false,

  /** Edit details: upload a photo or generate an AI mockup. */
  customMockups: false,

  /** Catalog embroidery method + hard hat blank. Restore list: riverr-scripts/omni-embroidery-restore.json */
  embroidery: false,

  /** Dashboard “Needs attention” Shopify token-expired / Reauthenticate card. */
  shopReauthenticate: false,

  /** Add-shop MyCart card. Existing MyCart shops stay. */
  mycartAddShop: false,
};

/** Permanent 2.3.1 — install only from the App Store, never type a shop URL. */
export const SHOPIFY_APP_STORE_PERMANENT = {
  shopUrlConnectHidden: true,
};

export function shopifyHoldOn(key) {
  return !!SHOPIFY_APP_STORE_HOLDS.enabled && !!SHOPIFY_APP_STORE_HOLDS[key];
}
